export default "__VITE_ASSET__C_QSY0Vg__"